import { useEffect } from "react";
import { ZIndexes } from "@glossy";
import { useStickyElement } from "@lkf/hooks";

export default (zIndex: ZIndexes, sticky?: boolean) => {
  const ref = useStickyElement();

  useEffect(() => {
    if (ref.current) {
      ref.current.style.zIndex = zIndex.toString();
    }
  }, [ref, zIndex]);

  return sticky ? ref : null;
};
